import MyTable from 'components/UIElements/MyTable';

export default function EmissionsStatus({ endPoint, exportFilename }) {
  const columns = [
    {
      title: 'No',
      key: 'no',
      dataIndex: 'no'
    },
    {
      title: 'policyNo',
      key: 'policyNo',
      dataIndex: 'policyNo'
    },
    {
      title: 'Channel',
      key: 'channel',
      dataIndex: 'channel'
    },
    {
      title: 'status',
      key: 'status',
      dataIndex: 'status'
    },
    {
      title: 'policy_StartDate',
      key: 'policy_StartDate',
      dataIndex: 'policy_StartDate'
    },
    {
      title: 'policy_ExpirationDate',
      key: 'policy_ExpirationDate',
      dataIndex: 'policy_ExpirationDate'
    },
    {
      title: 'policy_Duration',
      key: 'policy_Duration',
      dataIndex: 'policy_Duration'
    },
    {
      title: 'klm_Covered',
      key: 'klm_Covered',
      dataIndex: 'klm_Covered'
    },
    {
      title: 'kgCO2',
      key: 'kgCO2',
      dataIndex: 'kgCO2'
    },
    {
      title: 'contactNo',
      key: 'contactNo',
      dataIndex: 'contactNo'
    },
    {
      title: 'infoDate',
      key: 'infoDate',
      dataIndex: 'infoDate'
    }
  ];

  return (
    <MyTable
      columns={columns}
      endPoint={endPoint}
      exportFilename={exportFilename}
    />
  );
}
